<template>
  <div class="modal fade" id="objectOneCModal" tabindex="-1" aria-labelledby="objectOneCModalLabel" aria-hidden="true" @keydown.esc="clearForm">
    <div class="modal-dialog">
      <div class="modal-content">
        <div class="modal-header p-5">
          <h5 class="modal-title" id="objectOneCModalLabel">Объект</h5>
          <button type="button" @click="clearForm" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
        </div>
        <div class="modal-body p-5">
          <div v-if="error" class="alert alert-dismissible bg-danger d-flex flex-column flex-sm-row w-100 p-5 mb-5">
            <div class="d-flex flex-column text-light pe-0 pe-sm-10">
              <span v-html="error"></span>
            </div>
          </div>
          <div class="form-floating mb-5">
            <select
                class="form-select form-select-solid"
                aria-label="Местонахождение объекта"
                v-model="object.region_id"
                name="object.region_id"
                id="object.region_id"
            >
              <option
                  v-for="item in regions"
                  v-html="item.name"
                  :value="item.id"
                  :key="item.id"
              ></option>
            </select>
            <label for="object.region_id" class="required">Местонахождение объекта</label>
          </div>
          <input-field
              v-model="object.address"
              :required="true"
              id="object.address"
              name="object.address"
              placeholder="Территория страхования (адрес, этаж, № помещения)"
              type="text"
              mb="5"
          />
          <div class="row">
            <div :class="isImmovable ? 'col-md-6' : 'col-md-12'">
              <input-field
                  v-model="object.year"
                  @change="getvalidatedObjectYear(object.year)"
                  :required="true"
                  :has-error="!validatedObjectYear"
                  id="object.year"
                  name="object.year"
                  placeholder="Год постройки"
                  type="date"
                  mb="5"
              >
                <div v-if="!validatedObjectYear" class="text-danger ms-4 mt-2 fs-8">Год не может быть меньше 1963</div>
              </input-field>
            </div>
            <div v-if="isImmovable" class="col-md-6">
              <div class="custom-select dynamic">
                <label for="object.cond_id" class="required">Состояние постройки</label>
                <v-select
                    v-model="object.cond_id"
                    input-id="object.cond_id"
                    :options="dCond"
                    :reduce="item => item.id"
                    placeholder="Выберите..."
                    class="mb-5 bg-gray-100 form rounded"
                    label="name"
                />
              </div>
            </div>
            <div v-if="isImmovable" class="col-md-6">
              <div class="custom-select dynamic">
                <label for="object.kind_id" class="required">Тип постройки</label>
                <v-select
                    v-model="object.kind_id"
                    input-id="object.kind_id"
                    :options="dKinds"
                    :reduce="item => item.id"
                    placeholder="Выберите..."
                    class="mb-5 bg-gray-100 form rounded"
                    label="name"
                />
              </div>
            </div>
            <div v-if="isImmovable" class="col-md-6">
              <div class="custom-select dynamic">
                <label for="object.wall_id" class="required">Стены, материал постройки</label>
                <v-select
                    v-model="object.wall_id"
                    input-id="object.wall_id"
                    :options="dWall"
                    :reduce="item => item.id"
                    placeholder="Выберите..."
                    class="mb-5 bg-gray-100 form rounded"
                    label="name"
                />
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-6">
              <div class="form-floating mb-5">
                <money3
                    v-model.number="object.cost"
                    v-bind="config"
                    class="form-control form-control-solid"
                    placeholder="Действительная стоимость"
                    required
                    type="text"
                    name="object.cost"
                    id='object.cost'
                />
                <label for='object.cost' class="required">Действительная стоимость</label>
              </div>
            </div>
            <div class="col-6">
              <div class="form-floating mb-5">
                <money3
                    v-model.number="object.amount"
                    v-bind="config"
                    class="form-control form-control-solid"
                    placeholder="Страховая сумма"
                    required
                    type="text"
                    name="object.amount"
                    id='object.amount'
                />
                <label for='object.amount' class="required">Страховая сумма</label>
              </div>
            </div>
          </div>
          <input-field
              v-model="object.loan_number"
              id="object.loan_number"
              name="object.loan_number"
              placeholder="Номер договора залога/банковского займа"
              type="text"
              :required="!this.isBeneficiaryInWhitelist"
              mb="5"
          />
          <area-field
              v-model="object.add_info"
              :required="true"
              id="object.add_info"
              name="object.add_info"
              class="h-auto h-125px mt-5"
              placeholder="Введите информацию об объекте страхования"
              mb="5"
          />
          <div class="info-panel rounded border p-5 mb-5">
            <h5 class="text-gray-700 mb-5 fs-7 required" v-html="'Вид деятельности на территории страхования'"></h5>
            <div class="form-check form-check-custom form-check-solid form-check-sm mb-3" v-for="(item, key) in this.activity()" @click="object.activity = item; object.selected.activity = key">
              <input class="form-check-input" type="radio" :checked="this.object.selected.activity === key" :id="'object-activity-'+key" name="object-activity"/>
              <label class="form-check-label" :for="'object-activity-'+key" v-html="item"></label>
            </div>
          </div>
          <div class="info-panel rounded border p-5 mb-5">
            <h5 class="text-gray-700 mb-5 fs-7 required" v-html="'Передаваемое на страхование имущество принадлежит'"></h5>
            <div class="form-check form-check-custom form-check-solid form-check-sm mb-3" v-for="(item, key) in this.ownership()" @click="object.ownership = item; object.selected.ownership = key">
              <input class="form-check-input" type="radio" :checked="this.object.selected.ownership === key" :id="'object-ownership-'+key" name="object-ownership"/>
              <label class="form-check-label" :for="'object-ownership-'+key" v-html="item"></label>
            </div>
          </div>
          <input-field
              v-model="object.landlord"
              :required="true"
              id="object.landlord"
              name="object.landlord"
              placeholder="Собственник (арендодатель): Наименование / ФИО, БИН /ИИН"
              type="text"
              mb="5"
          />
          <input-field
              v-model="object.tenant"
              :required="true"
              id="object.tenant"
              name="object.tenant"
              placeholder="Владелец (арендатор): Наименование / ФИО, БИН /ИИН"
              type="text"
              mb="5"
          />
          <div class="info-panel rounded border p-5 mb-5">
            <h5 class="text-gray-700 mb-5 fs-7 required" v-html="'Состояние имущества'"></h5>
            <div class="form-check form-check-custom form-check-solid form-check-sm mb-3" v-for="(item, key) in this.condition()" @click="object.condition = item; object.selected.condition = key">
              <input class="form-check-input" type="radio" :checked="this.object.selected.condition === key" :id="'object-condition-'+key" name="object-condition"/>
              <label class="form-check-label" :for="'object-condition-'+key" v-html="item"></label>
            </div>
          </div>
          <switch-box-field
              v-model="object.has_access_system"
              placeholder="Существует ли на предприятии пропускная система"
              id="object.has_access_system"
              :size="'h-20px w-30px'"
              class="mb-5"
          />
          <switch-box-field
              v-model="object.has_security"
              placeholder="Наличие физической охраны объектов (присутствие охранников)"
              id="object.hasSecurity"
              :size="'h-20px w-30px'"
              class="mb-5"
          />
          <div class="info-panel rounded border p-5 mt-5 mb-5" v-if="object.has_security">
            <h5 class="text-gray-700 mb-5 fs-7 required">Режим охраны</h5>
            <div
                v-for="(item, key) in this.securityMode()"
                @click="object.security = item; object.selected.securityMode = key"
                class="form-check form-check-custom form-check-solid form-check-sm mb-3"
            >
              <input class="form-check-input" type="radio" :checked="object.selected.securityMode === key" :id="'security-mode-'+key" name="securityMode"/>
              <label class="form-check-label" :for="'security-mode-'+key" v-html="item"></label>
            </div>
          </div>
          <div class="info-panel rounded border p-5 mb-5">
            <h5 class="text-gray-700 mb-5 fs-7 required">
              Установлена ли в помещениях страхователя исправная автоматическая пожарная сигнализация
            </h5>
            <div
                v-for="(item, key) in this.fireAlarm()"
                @click="object.fire_alarm = key; object.selected.fireAlarm = key"
                class="form-check form-check-custom form-check-solid form-check-sm mb-5"
            >
              <input class="form-check-input" type="radio" :checked="object.selected.fireAlarm === key" :id="'fire-alarm-'+key" name="fire-alarm"/>
              <label class="form-check-label" :for="'fire-alarm-'+key" v-html="item"></label>
            </div>
          </div>
          <area-field
              v-model="object.dangers"
              id="object.dangers"
              name="object.dangers"
              :class="'h-125px'"
              class="h-auto mb-5"
              placeholder="Особые факторы, представляющие опасность"
              type="text"
          />
          <div class="rounded border p-3 mb-3">
            <switch-box-field
                v-model="showContracts"
                placeholder="Есть ли у Вас действующие договоры страхования по указанному в заявлении имуществу?"
                id="contract.hasContract"
                :size="'h-20px w-30px'"
            />
            <area-field
                v-if="showContracts"
                v-model="object.contracts"
                id="object.contracts"
                name="object.contracts"
                class="h-auto h-100px mt-5"
                placeholder="Если есть, коротко о договоре."
            />
          </div>
        </div>
        <div class="modal-footer p-3 justify-content-between">
          <button
              @click="clearForm"
              type="button"
              class="btn btn-sm btn-secondary"
              data-bs-dismiss="modal"
          >Закрыть</button>
          <button
              :disabled="!valid"
              @click="addObject"
              type="button"
              class="btn btn-sm btn-primary"
              v-html="'Добавить'">
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// Field
import SwitchBoxField       from '@/components/Fields/SwitchBoxField'
import InputField           from '@/components/Fields/InputField'
import AreaField            from '@/components/Fields/AreaField'
// Other
import { Money3Component }  from 'v-money3'
import vSelect from "vue-select";

export default {
  name: 'PropertyOneCModal',
  components: {vSelect, money3: Money3Component, SwitchBoxField, InputField, AreaField },
  props: {
    isPerson: {
      type: Boolean,
      default: false
    },
    properties: {
      type: Object,
      default: null
    },
    module: {
      type: Function,
      required: true
    },
    beneficiary: {
      type: Object,
      default: null
    },
    isImmovable: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      object: {
        has_access_system: false, //bool
        has_security:      false, //bool
        loan_number:       null,
        fire_alarm:        null,
        contracts:         null,
        condition:         null,
        region_id:         null,
        ownership:         null,
        activity:          null,
        add_info:          null,
        landlord:          null,
        security:          null,
        address:           null,
        dangers:           null,
        premium:           0,
        amount:            0,
        tenant:            null,
        cost:              0,
        year:              null,
        kind_id:           null, // Тип постройки
        cond_id:           null, // Состояние постройки
        wall_id:           null, // Стены, материал постройки
        selected: {
          securityMode:   null,
          ownership:      null,
          condition:      null,
          fireAlarm:      null,
          activity:       null,
        },
      },
      showContracts:  false,
      valid:          false,
      validatedObjectYear: true,
      validatedObjectDict: true,
      error:          null,
      config: {
        precision:  2,
        thousands:  ' ',
        decimal:    '.',
        prefix:     '',
        suffix:     ' ₸',
        masked:     false
      },
      dKinds: [
        {id: '000000075', name: 'АЗС'},
        {id: '000000079', name: 'Баня/банный комплекс/сауна'},
        {id: '000000070', name: 'Бизнес центр'},
        {id: '000000068', name: 'Гараж'},
        {id: '000000078', name: 'Гостиница'},
        {id: '000000063', name: 'Дом'},
        {id: '000000064', name: 'Дом с З/У'},
        {id: '000000065', name: 'З/У (без даты)'},
        {id: '000000066', name: 'Квартира'},
        {id: '000000067', name: 'Офис'},
        {id: '000000069', name: 'Парковочное место'},
        {id: '000000073', name: 'Производственные цеха/Заводские помещения'},
        {id: '000000071', name: 'Пром.база'},
        {id: '000000072', name: 'Пром.база с З/У'},
        {id: '000000080', name: 'Прочее'},
        {id: '000000074', name: 'Склад'},
        {id: '000000077', name: 'Стадион'},
        {id: '000000076', name: 'Театр'},
      ],
      dCond: [
        {id: '000000081', name: 'Законченное строение'},
        {id: '000000082', name: 'Незаконченное строение'},
      ],
      dWall: [
        {id: '000000083', name: 'Кирпич'},
        {id: '000000084', name: 'Брус'},
        {id: '000000085', name: 'Ж/б блоки'},
        {id: '000000086', name: 'Бетон'},
        {id: '000000087', name: 'Монолит'},
        {id: '000000088', name: 'Деревянный'},
        {id: '000000089', name: 'Саманный'},
        {id: '000000090', name: 'Каркасно-камышитовый'},
        {id: '000000091', name: 'Щитовой'},
        {id: '000000092', name: 'Шпальный'},
        {id: '000000093', name: 'Глиняный'},
        {id: '000000094', name: 'Газоблок'},
      ]
    }
  },
  computed: {
    regions() { return this.$store.getters.getRegionsFI },
    isBeneficiaryInWhitelist() { return this.beneficiary ? this.module.Validator.validateBeneficiaryWhiteList(this.beneficiary.client.iin) : false },
  },
  methods: {
    securityMode()   { return this.module.Dictionary.securityMode() },
    fireAlarm()      { return this.module.Dictionary.fireAlarm() },
    ownership()      { return this.module.Dictionary.ownership() },
    condition()      { return this.module.Dictionary.condition() },
    activity()       { return this.module.Dictionary.activity() },
    modalHidden() {
      const myModalEl = document.getElementById('objectOneCModal');
      const modal     = bootstrap.Modal.getInstance(myModalEl);
      modal.hide();
    },
    clearForm() {
      this.object   = this.module.Object.empty()
      this.valid    = false
      this.error    = null
      this.showContracts = false
    },
    addObject() {
      this.$emit('addObject', {
        data:   this.object,
        isEdit: this.properties.isEdit,
        key:    this.properties.key
      })
      setTimeout(() => { this.clearForm() }, 100)
      this.modalHidden()
    },
    validateCostAndAmount () {
      this.error = null
      if (parseInt(this.object.amount) > parseInt(this.object.cost)) {
        this.error = '"Страховая сумма" не должна быть больше "Действительная стоимость"'
        this.valid = false
      }
      if (this.isPerson && parseInt(this.object.amount) > 500000000) {
        this.error = '"Страховая сумма" не должна быть больше 500 000 000 тг.'
        this.valid = false
      }
      if (!this.isPerson && parseInt(this.object.amount) > 2000000000) {
        this.error = '"Страховая сумма" не должна быть больше 2 000 000 000 тг.'
        this.valid = false
      }
    },
    getvalidatedObjectYear(val) {
      if (val) {
        const year = parseInt(val.slice(0, 4));
        this.validatedObjectYear = 1963 < year
      } else this.validatedObjectYear = false;
    },
    getValidatedObjectDict(kind, cond, wall) {
      const bannedKinds = ['000000079', '000000080']
      if (bannedKinds.includes(kind)) {
        this.error = 'Выбранный объект не подлежит страхованию'
        return false
      }
      if (cond === '000000082') {
        this.error = 'Страхование незавершённого строения недопустимо'
        return false
      }
      const bannedWalls = ['000000088', '000000089', '000000090', '000000091', '000000092', '000000093']
      if (bannedWalls.includes(wall)) {
        this.error = 'Объекты с выбранным материалом стен не принимаются на страхование'
        return false
      }
      this.error = null
      return true
    },
    validatorObject(newValue) {
      let object = structuredClone(newValue)
      delete object.selected
      delete object.premium
      delete object.contracts
      delete object.dangers
      delete object.has_access_system
      if (!object.has_security) {
        delete object.security
      }
      if (!this.isImmovable) {
        delete object.kind_id
        delete object.cond_id
        delete object.wall_id
      }
      if (this.isBeneficiaryInWhitelist) delete object.loan_number
      delete object.has_security
      const amount = parseInt(this.object.amount) > (this.isPerson ? 500000000 : 2000000000)
      if (newValue.year) this.getvalidatedObjectYear(newValue.year)
      if (this.isImmovable) this.validatedObjectDict = this.getValidatedObjectDict(object.kind_id, object.cond_id, object.wall_id)
      this.valid = this.module.Validator.simple(object) && !amount && this.validatedObjectYear && this.validatedObjectDict
      if (this.valid) this.error = null
    }
  },
  watch: {
    object: {
      deep: true,
      handler (newValue) {
        this.validatorObject(newValue)
      }
    },
    properties: {
      deep: true,
      handler (newValue) {
        this.clearForm()
        this.object = newValue.isEdit ? newValue.data : this.module.Object.empty()
      }
    },
    'object.contracts': {
      immediate: true,
      handler (newVal, oldVal) {
        this.showContracts = !!(newVal || oldVal)
        if (!newVal) this.showContracts = false
      }
    },
    'object.cost': {
      immediate: true,
      handler () {
        this.validateCostAndAmount()
      }
    },
    'object.amount': {
      immediate: true,
      handler () {
        this.validateCostAndAmount()
      }
    }
  }
}
</script>

<style scoped></style>
